import React from "react";
import { Container } from "react-bootstrap";

const PitchCapex = () => {
  return (
    <>
      <section className="py-5">
        <Container>
          <p className="section-subtitle  text-start mb-2 px-3 pb-3">Capex</p>
          {/* first table */}
          <div className="scroll-x">
          <table className="custom-table">
            <thead>
              <tr>
                <th>CAPEX</th>
                <th>Year 01</th>
                <th>Year 02</th>
                <th>Year 03</th>
                <th>Year 04</th>
                <th>Year 05</th>
              </tr>
            </thead>
            <tbody>
              <tr className="active">
                <td>
                  <div className="row-badge-wrapper">
                    <div className="row-badge">54%</div>
                  </div>
                  <span className="badge-cell">Open Stores & Warehouses</span>
                </td>
                <td>  $ 45,360,000 </td>
                <td>   $ 116,640,000  </td>
                <td> $155,520,000</td>
                <td> $155,520,000</td>
                <td> $181,440,000</td>
              </tr>
              <tr className="active">
                <td>
                  <div className="row-badge-wrapper">
                    <div className="row-badge">25%</div>
                  </div>
                  <span className="badge-cell">Raw Materials</span>
                </td>
                <td>  $ 21,000,000 </td>
                <td>  $ 54,000,000 </td>
                <td> $72,000,000</td>
                <td> $72,000,000</td>
                <td> $84,000,000</td>
              </tr>
              <tr className="active">
                <td>
                  <div className="row-badge-wrapper">
                    <div className="row-badge">21%</div>
                  </div>
                  <span className="badge-cell">Other Setup Costs</span>
                </td>
                <td>  $ 17,640,000 </td>
                <td>   $ 45,360,000 </td>
                <td>  $ 60,480,000 </td>
                <td> $60,480,000</td>
                <td> $70,560,000</td>
              </tr>
              {/*  */}
              <tr>
                <td>Payroll</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
              </tr>
              <tr>
                <td>Other start-up costs</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
              </tr>
              <tr>
                <td>Research & Development</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
              </tr>
              <tr>
                <td>Investments</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
              </tr>
              <tr>
                <td>Other Setup Costs</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
              </tr>
              <tr>
                <td>Other Setup Costs</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
                <td>$</td>
              </tr>
              <tr>
                <td className="lead-cell">Total CAPEX</td>
                <td>  $ 84,000,000 </td>
                <td>  $ 216,000,000 </td>
                <td> $288,000,000</td>
                <td> $288,000,000</td>
                <td> $336,000,000</td>
              </tr>
              <tr>
                <td className="lead-cell">COGS</td>
                <td> $1,991,808,000</td>
                <td>  $ 11,097,216,000 </td>
                <td> $25,950,412,800</td>
                <td> $42,340,147,200</td>
                <td> $60,209,510,400</td>
              </tr>
              <tr>
                <td className="lead-cell">OPEX</td>
                <td> $2,663,796,660</td>
                <td>  $ 2,930,176,326 </td>
                <td> $3,063,366,159</td>
                <td> $3,196,555,992</td>
                <td> $3,329,745,825</td>
              </tr>
              <tr>
                <td className="lead-cell">Interest & Dividend & Tax</td>
                <td> $450,401,301</td>
                <td>  $ 2,719,487,925 </td>
                <td> $6,659,356,680</td>
                <td> $11,354,181,480</td>
                <td> $18,981,513,000</td>
              </tr>
              <tr>
                <td className="lead-cell primary">Capital Required</td>
                <td> $5,190,005,961</td>
                <td>  $ 16,962,880,251 </td>
                <td> $35,961,135,639</td>
                <td> $57,178,884,672</td>
                <td> $82,856,769,225</td>
              </tr>
              <tr>
                <td>Opening Cash</td>
                <td> $-</td>
                <td>  $ 7,660,800,000 </td>
                <td> $32,166,311,826</td>
                <td> $73,427,130,159</td>
                <td> $137,505,771,879</td>
              </tr>
              <tr>
                <td>Loan</td>
                <td className="active start-cell"> $-</td>
                <td className="active"> $-</td>
                <td className="active"> $-</td>
                <td className="active"> $-</td>
                <td className="active"> $-</td>
              </tr>
              <tr>
                <td>Owner's Equity Injection</td>
                <td> $5,190,005,961</td>
                <td>  $ 9,302,080,251 </td>
                <td> $3,794,823,813</td>
                <td> $-</td>
                <td> $-</td>
              </tr>
            </tbody>
          </table>
          </div>
        </Container>
      </section>
    </>
  );
};

export default PitchCapex;
